/* eslint-disable @typescript-eslint/no-unsafe-function-type */
/* eslint-disable @typescript-eslint/no-explicit-any */

import CTL_Button from "@/compo/CTL_Button";
import { CTL_Input } from "@/compo/CTL_Input";
import { getDateString } from "@/util";
import axios from "axios";
import { useState } from "react";
import ReactQuill from "react-quill-new";

//------------------------
interface Prop_NoticeListRow {
  idx: number;
  reg_date: string;
  contents: string;
  subject: string;
  showContents: boolean;
  showLine?: boolean;
  onClick?: () => void;
  onUpdate?:(info:unknown)=>void;
}
export function NoticeListRow(prop: Prop_NoticeListRow) {
  const [deleteAskMode, set_deleteAskMode] = useState(false);
  const [editMode, set_editMode] = useState(false);
  const [contents, set_contents] = useState(prop.contents);
  const [subject, set_subject] = useState(prop.subject);
  
  async function _deleteNotice(){
    const {data} = await axios.post('/notice/remove',{idx:prop.idx});
    if(prop.onUpdate)prop.onUpdate(data)
  }
  async function _modifyNotice(){
    const {data} = await axios.post('/notice/modify',{
      idx:prop.idx,
      contents:contents,
      subject:subject,
    });
    set_editMode(false);
    if(prop.onUpdate)prop.onUpdate(data)
  }
  
  function _cancelEdit(){
    set_editMode(false);
    set_contents( prop.contents )
    set_subject( prop.subject )
  }

  
  return (
    <div
      className="
      
      flex flex-col w-full 
      cursor-pointer select-none"

    >
      <div
        className={`
          ${prop.showContents == true&&'bg-zinc-100'}
          p-1
          hover:bg-zinc-100 transition-colors
          px-1
        `}
        onClick={() => prop.onClick && prop.onClick()}
      >
        <div className={`
          ${prop.showContents == true?'bg-white py-1 px-2 rounded-lg':'bg-transparent'}
          w-full flex gap-2 items-center
        `}>
          <div className="text-zinc-500">
            {getDateString("yyyy-MM-dd", new Date(prop.reg_date))}
          </div>
          {editMode==false&&<div className="text-black">{prop.subject}</div>}
          {editMode==true&&
            <div className="flex-1">
            <CTL_Input 
              value={subject}
              onChange={(v: string) => set_subject(v)}
            />
          </div>}
        </div>
      </div>

      {prop.showContents == true && (
        <div className="flex flex-col items-center bg-zinc-100 p-1 pt-0">
          
          <div className="w-full bg-white rounded-lg">
            <ReactQuill
              theme={editMode?'snow':''}
              className="border border-zinc-50 w-full"
              readOnly={!editMode}
              value={contents}
              onChange={set_contents}
            />
          </div>
          
          {editMode==false&&deleteAskMode==false&&
            <div className="w-full flex gap-2 justify-end pt-1">
              <CTL_Button className="bg-white text-red-600 border-red-300!" onClick={()=>set_deleteAskMode(true)}>삭제</CTL_Button>
              <CTL_Button className="bg-white text-blue-600 border-blue-300!" onClick={()=>set_editMode(true)}>수정</CTL_Button>
            </div>
          }
          {editMode==false&&deleteAskMode==true&&
            <div className="w-full flex gap-2 justify-end pt-1">
              <div className="flex-1 px-2 text-red-700">정말로 해당 게시물을 삭제하겠습니까? <br/> 삭제후에는 복원할 수 없습니다.</div>
              <CTL_Button className="bg-white " onClick={()=>set_deleteAskMode(false)}>취소</CTL_Button>
              <CTL_Button className="bg-white text-red-600 border-red-300!" onClick={()=>_deleteNotice()}>삭제</CTL_Button>
            </div>
          }
          {editMode==true&&
            <div className="w-full flex gap-2 justify-end pt-1">
              <CTL_Button className="bg-white " onClick={()=>_cancelEdit()}>취소</CTL_Button>
              <CTL_Button className="bg-white text-blue-600 border-blue-300!" onClick={()=>_modifyNotice()}>적용</CTL_Button>
            </div>
          }

        </div>
      )}
      {prop.showLine && (
        <div className="w-full border-dashed border-b border-zinc-300" />
      )}
    </div>
  );
}

//------------------------

interface Prop_NoticeList {
  className?: string;
  data?: Array<any>;
  onUpdate?:(info:unknown)=>void;
}
export default function NoticeList(prop: Prop_NoticeList) {
  const [showContentsID, setShowContentsID] = useState(0);
  return (
    prop.data &&
    prop.data.map((v: any, i: number) => (
      <NoticeListRow
        key={v.idx}
        {...v}
        showContents={v.idx == showContentsID}
        showLine={prop.data!.length - 1 > i}
        onClick={() =>
          showContentsID == v.idx
            ? setShowContentsID(0)
            : setShowContentsID(v.idx)
        }
        onUpdate={(info:unknown)=>prop.onUpdate&&prop.onUpdate(info)}
      />
    ))
  );
}
